// This file is generated. Do not modify it.
// See: packages/pulse/scripts/transpile-variables.ts
export const lightColorBase = {
  neutral: {
    granite: {
      "25": "#f2f2f2",
      "50": "#e9e9e9",
      "100": "#d0d0d0",
      "200": "#b5b5b5",
      "300": "#949494",
      "400": "#696969",
      "500": "#656565",
      "600": "#515151",
      "700": "#3d3d3d",
      "800": "#282828",
      "900": "#141414",
      "950": "#080808",
    },
    ghost: {
      "25": "#fcfcfe",
      "50": "#fafafd",
      "100": "#f5f5fa",
      "200": "#f0f0f8",
      "300": "#ebebf5",
      "400": "#e6e5f3",
      "500": "#e1e0f0",
      "600": "#c9c8d7",
      "700": "#a2a2ad",
      "800": "#878690",
      "900": "#65646b",
      "950": "#403f44",
    },
    base: {
      white: "#ffffff",
      black: "#000000",
    },
  },
  brand: {
    iris: {
      "50": "#f3f3fa",
      "100": "#e7e6f6",
      "200": "#cbcbec",
      "300": "#acaae2",
      "400": "#8583d7",
      "500": "#4c47cc",
      "600": "#4440b6",
      "700": "#3b379e",
      "800": "#302d81",
      "900": "#22205b",
    },
    ultramarine: {
      "50": "#f3f4fd",
      "100": "#e6e8fc",
      "200": "#cacff9",
      "300": "#aab2f6",
      "400": "#8190f2",
      "500": "#4462ef",
      "600": "#3352cf",
      "700": "#2b42a3",
      "800": "#123187",
      "900": "#0d2360",
    },
    meadow: {
      "50": "#f2faf7",
      "100": "#e4f5ef",
      "200": "#c6eade",
      "300": "#a2dfcb",
      "400": "#74d3b6",
      "500": "#19c79f",
      "600": "#16b28e",
      "700": "#139a7b",
      "800": "#107e65",
      "900": "#0b5947",
    },
    blush: {
      "50": "#fdf3f5",
      "100": "#fce7ea",
      "200": "#f9ccd3",
      "300": "#f6acba",
      "400": "#f2869c",
      "500": "#ef4e77",
      "600": "#d13f64",
      "700": "#b93c5c",
      "800": "#97314b",
      "900": "#6b2335",
    },
    clementine: {
      "50": "#fdf7f3",
      "100": "#fcf0e7",
      "200": "#f9dfcc",
      "300": "#f6ceac",
      "400": "#f2bb86",
      "500": "#efa54e",
      "600": "#d69446",
      "700": "#b9803c",
      "800": "#976831",
      "900": "#6b4a23",
    },
    persianRed: {
      "50": "#faf3f2",
      "100": "#f6e5e5",
      "200": "#ecc9c8",
      "300": "#e2a7a5",
      "400": "#d87d7a",
      "500": "#cd392f",
      "600": "#b7332a",
      "700": "#9f2c24",
      "800": "#82241e",
      "900": "#5c1915",
    },
  },
  transparent: {
    "2": "rgba(0, 0, 0, 0.0196078431372549)",
    "4": "rgba(0, 0, 0, 0.0392156862745098)",
    "8": "rgba(0, 0, 0, 0.0784313725490196)",
    "12": "rgba(0, 0, 0, 0.12156862745098039)",
    "20": "rgba(0, 0, 0, 0.2)",
    "30": "rgba(0, 0, 0, 0.30196078431372547)",
    "40": "rgba(0, 0, 0, 0.4)",
    "50": "rgba(0, 0, 0, 0.5019607843137255)",
    "60": "rgba(0, 0, 0, 0.6)",
    "70": "rgba(0, 0, 0, 0.7019607843137254)",
    "80": "rgba(0, 0, 0, 0.8)",
    "90": "rgba(0, 0, 0, 0.9019607843137255)",
  },
  accents: {
    pink: {
      "100": "#fbe9f0",
      "200": "#f5c6d7",
      "500": "#cc346b",
    },
    red: {
      "100": "#fbe9ec",
      "200": "#f5c6cc",
      "500": "#cc3446",
    },
    redOrange: {
      "100": "#fbefe9",
      "200": "#f5d4c6",
      "500": "#cc6134",
    },
    yellow: {
      "100": "#faf8ea",
      "200": "#f2ebc4",
      "500": "#ccb434",
    },
    yellowGreen: {
      "100": "#f4faea",
      "200": "#e1f2c4",
      "500": "#80b22d",
    },
    green: {
      "100": "#e9fbf4",
      "200": "#c6f5e1",
      "500": "#2db27b",
    },
    teal: {
      "100": "#e9fafb",
      "200": "#c6f2f5",
      "500": "#31b7bf",
    },
    blue: {
      "100": "#e9f1fb",
      "200": "#c6d9f5",
      "500": "#3471cc",
    },
    indigo: {
      "100": "#e9eafb",
      "200": "#c6c8f5",
      "500": "#4034cc",
    },
    purple: {
      "100": "#efe9fb",
      "200": "#d5c6f5",
      "500": "#6534cc",
    },
    magenta: {
      "100": "#f9e8fc",
      "200": "#eaabf5",
      "500": "#b734cc",
    },
    orange: {
      "100": "#fbf3e9",
      "200": "#f5dfc6",
      "500": "#cc8634",
    },
  },
};
export const darkColorBase = {
  brand: {
    iris: {
      "50": "#2c2b48",
      "100": "#3e3d66",
      "200": "#585690",
      "300": "#6c69b0",
      "400": "#807fd1",
      "500": "#8b88e3",
      "600": "#a9a7e9",
      "700": "#c2c1ef",
      "800": "#d8d7f4",
      "900": "#ececfa",
    },
    ultramarine: {
      "50": "#1a1f4b",
      "100": "#252c6a",
      "200": "#343f95",
      "300": "#404db7",
      "400": "#4959d3",
      "500": "#5263ec",
      "600": "#8890f0",
      "700": "#adb3f4",
      "800": "#cccff8",
      "900": "#e7e8fb",
    },
    meadow: {
      "50": "#083f32",
      "100": "#0b5947",
      "200": "#107e65",
      "300": "#139a7b",
      "400": "#16b28e",
      "500": "#19c79f",
      "600": "#74d3b6",
      "700": "#a2dfcb",
      "800": "#c6eade",
      "900": "#e4f5ef",
    },
    clementine: {
      "50": "#4c3419",
      "100": "#6b4a23",
      "200": "#976831",
      "300": "#b9803c",
      "400": "#d69446",
      "500": "#efa54e",
      "600": "#f2bb86",
      "700": "#f6ceac",
      "800": "#f9dfcc",
      "900": "#fcf0e7",
    },
    blush: {
      "50": "#4c1926",
      "100": "#6b2335",
      "200": "#97314b",
      "300": "#b93c5c",
      "400": "#c64263",
      "500": "#ef4e77",
      "600": "#f2869c",
      "700": "#f6acba",
      "800": "#f9ccd3",
      "900": "#fce7ea",
    },
    persianRed: {
      "50": "#41120f",
      "100": "#5c1915",
      "200": "#82241e",
      "300": "#9f2c24",
      "400": "#b7332a",
      "500": "#cd392f",
      "600": "#de5a50",
      "700": "#de7169",
      "800": "#ee958f",
      "900": "#edb6b2",
    },
  },
  neutral: {
    granite: {
      "25": "#060606",
      "50": "#141414",
      "100": "#262626",
      "200": "#383838",
      "300": "#4d4d4d",
      "400": "#737373",
      "500": "#949494",
      "600": "#b3b3b3",
      "700": "#cccccc",
      "800": "#e6e6e6",
      "900": "#f2f2f2",
      "950": "#fafafa",
    },
    ghost: {
      "25": "#111118",
      "50": "#1a1a23",
      "100": "#22222f",
      "200": "#363347",
      "300": "#4f4d6a",
      "400": "#67678e",
      "500": "#8d8cab",
      "600": "#a6a6bf",
      "700": "#cccad8",
      "800": "#e3e1ea",
      "900": "#ededf2",
      "950": "#f9f9fb",
    },
    base: {
      white: "#262626",
      black: "#fafafa",
    },
  },
  transparent: {
    "2": "rgba(255, 255, 255, 0.0196078431372549)",
    "4": "rgba(255, 255, 255, 0.0392156862745098)",
    "8": "rgba(255, 255, 255, 0.0784313725490196)",
    "12": "rgba(255, 255, 255, 0.12156862745098039)",
    "20": "rgba(255, 255, 255, 0.2)",
    "30": "rgba(255, 255, 255, 0.30196078431372547)",
    "40": "rgba(255, 255, 255, 0.4)",
    "50": "rgba(255, 255, 255, 0.5019607843137255)",
    "60": "rgba(255, 255, 255, 0.6)",
    "70": "rgba(255, 255, 255, 0.7019607843137254)",
    "80": "rgba(255, 255, 255, 0.8)",
    "90": "rgba(255, 255, 255, 0.9019607843137255)",
  },
  accents: {
    pink: {
      "100": "#5b1730",
      "200": "#812144",
      "500": "#fbe9f0",
    },
    red: {
      "100": "#5b171f",
      "200": "#81212c",
      "500": "#fbe9ec",
    },
    redOrange: {
      "100": "#5b2b17",
      "200": "#813d21",
      "500": "#fbefe9",
    },
    orange: {
      "100": "#5b3c17",
      "200": "#815521",
      "500": "#fbf3e9",
    },
    yellow: {
      "100": "#5b5017",
      "200": "#817221",
      "500": "#faf8ea",
    },
    yellowGreen: {
      "100": "#395014",
      "200": "#51711c",
      "500": "#f4faea",
    },
    green: {
      "100": "#145037",
      "200": "#1c714e",
      "500": "#e9fbf4",
    },
    teal: {
      "100": "#165255",
      "200": "#1f7479",
      "500": "#e9fafb",
    },
    blue: {
      "100": "#17335b",
      "200": "#214781",
      "500": "#e5eaf6",
    },
    indigo: {
      "100": "#2a2182",
      "200": "#3c32c3",
      "500": "#e9eafb",
    },
    purple: {
      "100": "#2d175b",
      "200": "#402181",
      "500": "#efe9fb",
    },
    magenta: {
      "100": "#52175b",
      "200": "#742181",
      "500": "#f9e8fc",
    },
  },
};

export type ColorBase = typeof lightColorBase;
